import { EnumUTAFormTAField } from '@components-member/TradingAccounts/AccountCreate/enums';
import { IAccountCreationQueryParams } from '@components-member/TradingAccounts/hooks/useAccountCreationQueryParams';
import { IAccountType, IModalFormField } from '@components-member/socialTrading/social.interfaces';
import { FormUtils } from '@components-shared/forms/forms.utils';

export const getSocialTradingTypeOption = (
  types: IAccountType[],
  fields: IModalFormField[],
  platform?: IAccountCreationQueryParams['platformType'],
): void => {
  const typeFieldIdx = FormUtils.getFieldIndex(fields, EnumUTAFormTAField.type);

  if (typeFieldIdx > -1) {
    const options = types
      .filter((type) => !platform || platform === 'None' || type.tradingPlatformType === platform)
      .map((type) => ({ name: type.displayName, value: type.id }));

    FormUtils.updateFormField(typeFieldIdx, { options }, fields);
  }
};
